import { useEffect, useRef } from 'react';
import pick from 'lodash/pick';
import { useAuth } from 'utils/hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import { setPopup } from 'modules/popup/actions';
import { POPUP } from 'utils/constants/popup';
import { noop } from 'functions/noop';

const POPUP_DISPLAYING_TIMEOUT = 1000;

export const useProfileChanged = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const seeAllOptionsPopupShownRef = useRef(false);
  const {
    profile: { data: { providersPopup: { noProvidersMatched } = {} } },
    popup: { popup },
  } = useSelector((state) => pick(state, ['profile', 'popup']));

  const shouldShowSeeAllOptionsPopup = !!(
    isAuthenticated && !popup && noProvidersMatched && !seeAllOptionsPopupShownRef.current
  );

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }
    // init render / logout
    seeAllOptionsPopupShownRef.current = false;
  }, [isAuthenticated]);

  useEffect(() => {
    if (!shouldShowSeeAllOptionsPopup) {
      return noop;
    }

    const popupTimeout = setTimeout(() => {
      dispatch(setPopup({ type: POPUP.SEE_ALL_OPTIONS }));
      seeAllOptionsPopupShownRef.current = true;
    }, POPUP_DISPLAYING_TIMEOUT);

    return () => {
      if (popupTimeout) {
        clearTimeout(popupTimeout);
      }
    };
  }, [dispatch, shouldShowSeeAllOptionsPopup]);
};
